export default __webpack_public_path__ + "static/media/card1.2aac24fb.png";